<template>
 <div class="profile_image">
  <svg
  v-if="!userUrl"
  width="38"
  height="37"
  viewBox="0 0 38 37"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="0.5"
    y="0.5"
    width="36.0462"
    height="36"
    rx="18"
    fill="#EBF1FA"
    stroke="#EBF0F5"
  />
  <path
    d="M18.8571 18.5C22.035 18.5 24.6071 15.9279 24.6071 12.75C24.6071 9.5721 22.035 7 18.8571 7C15.6792 7 13.1071 9.5721 13.1071 12.75C13.1071 15.9279 15.6792 18.5 18.8571 18.5ZM22.8 20.1429H22.3739C21.306 20.6562 20.1201 20.9643 18.8571 20.9643C17.5942 20.9643 16.4134 20.6562 15.3404 20.1429H14.9143C11.6491 20.1429 9 22.792 9 26.0571V27.5357C9 28.8962 10.1038 30 11.4643 30H26.25C27.6105 30 28.7143 28.8962 28.7143 27.5357V26.0571C28.7143 22.792 26.0652 20.1429 22.8 20.1429Z"
    fill="#BACEEE"
  />
</svg>
<img v-else :src="userUrl" class="profile_image_img"/>
 </div>
</template>

<script>
export default {
  computed: {
    userUrl(){
      return this.$store.getters.user.imageurl
    }
  },
};
</script>

<style scoped lang="scss">
.profile_image{
  width: 35px;
  height: 35px;
  border-radius: 50px;
  overflow: hidden;
}
.profile_image_img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
}
</style>
